export default __webpack_public_path__ + "static/media/entreprendre.ef03ad72.jpg";